import { Injectable } from "@angular/core";

@Injectable()
export class MessageService{

       info(message: string, title?: string, options?: any): any {
    }

    success(message: string, title?: string, options?: any): any {
    }

    warn(message: string, title?: string, options?: any): any {
    }

    error(message: string, title?: string, options?: any): any {
    }

    confirm(message: string, title?: string, callback?: (result: boolean) => void, options?: any): any {
    }


}